import { createRouter, createWebHistory } from 'vue-router';
import OwnerForm from '../components/ownerForm.vue';
import GuestForm from '../components/guestForm.vue';
import updateOwnerForm from '../components/updateOwnerForm.vue';
import bookingInfo from '../components/bookingInfo.vue';
import PageNotFound from '../components/PageNotFound.vue';
import cancellationPage from '../components/cancellationPage.vue';
import ownerOrganicForm from '../components/ownerOrganicForm.vue';
import guestOrganicForm from '../components/guestOrganicForm.vue';
import guestConfirmForm from '../components/guestConfirmForm.vue';
import addtoCal from '../components/addtoCal.vue';
import activationOwnerForm from '../components/activationOwnerForm.vue';
import activationGuestForm from '../components/activationGuestForm.vue';
import bookingConfirmed from '../components/bookingConfirmed.vue';
const routes = [
  {
    path: '/guest',
    component: GuestForm
  },
  {
    path: '/guest-confirm',
    component: guestConfirmForm
  },

  
  {
    path: '/owner',
    component: OwnerForm
  },
  {
    path: '/owner-organic',
    component: ownerOrganicForm
  },
  {
    path: '/guest-organic',
    component: guestOrganicForm
  },
  {
    path: '/activation-owner',
    component: activationOwnerForm
  },
{
    path: '/activation-guest',
    component: activationGuestForm
},
  { path: '/booking-confirmed/:name', component: bookingConfirmed },

  
  {
    path: '/update-owner',
    component: updateOwnerForm
  }
  ,
  {
    path: '/bookingInfo',
    component: bookingInfo
  },
  {
    path: '/add-to-calendar',
    component: addtoCal
  },
  { path: '/:pathMatch(.*)*', component: PageNotFound },
  {path: '/booking-canceled', component: cancellationPage}


  

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;